<template>
    <div>
        <h1>Neues PCR Ger&auml;t verbinden</h1>


        <div v-if="!autoenter">
            Bitte geben Sie nachfolgend den Pairing Code ein, welcher am Bildschirm Ihres PCR Ger&auml;tes angezeigt wird.
            <br/><br/>
            <input :readonly="autoenter" style="    width: 230px;" v-model="pairingcode" max=999999 type="number" ref="pp" placeHolder="Pairing Code" />
        </div>
        <div v-else>
            Erfasstes Ger&auml;t: {{ pairingcode }}<br/><br/>
        </div>
        <div class="magic-button" v-on:click="Pairing()">PCR Ger&auml;t verbinden</div>

        <div class="error" v-if="error">
            Pairing ist fehlgeschlagen, bitte kontaktieren Sie unseren Support.
        </div>
        <div class="success" v-if="success">
            Ger&auml;t wurde verbunden.
        </div>
    </div>
</template>
<script>
export default ({
    data() {
        return {
            pairingcode: null,
            success: false,
            error: false,
            autoenter: false,
        }
    },
    methods: {
        Pairing() {
            if(this.pairingcode == "") return false;
            this.$store.dispatch("PairDevice", this.pairingcode)
            .then(() => {
                this.success = true;
                this.error = false;
            })
            .catch(() => {
                this.error = true;
                this.success = false;
                setTimeout(() => {
                    this.error = false;
                    this.success = false;
                }, 3000)
            })
        }
    },
    mounted() {
        let { id = false } = this.$route.params;
        if(id) {
            this.pairingcode = id;
            this.autoenter = true;
        }
        this.$refs.pp.focus();
    },
})
</script>
